export function updatePollState(state, payload) {
  state[payload.state] = payload.data;
}
